import { SYSTEM_ROLES } from '@repo/contracts';

import { selectHeldRoles } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

/** A maintainer's access lives in the sync console, not in this app. */
export function NoAccessMaintainerNote() {
  const held = useAppSelector(selectHeldRoles);

  if (!held.includes(SYSTEM_ROLES.maintainer)) return null;

  return (
    <span className="text-sm text-muted-foreground">
      Your Maintainer role is for the sync console, where you can see how the Zoho sync runs. There
      is nothing for it in this app.
    </span>
  );
}
